export default __webpack_public_path__ + "static/media/banner3.949075d5.png";